<template>
  <div>
    <el-form ref="formRef" :model="tagForm" label-width="88px">
      <el-form-item label="类目名称：">
        <el-input type="text" v-model="tagForm.name" placeholder="请输入类目名称" style="width:24em;"/>
      </el-form-item>
      <el-form-item label="排序：">
        <el-input type="text" v-model="tagForm.orderNum" placeholder="数字越大排序越靠前" style="width:24em;"/>
      </el-form-item>
<!--      <el-form-item label="内容：">-->
<!--        <el-input :autosize="{ minRows: 10, maxRows: 30}" type="textarea" v-model="infoLabelList" placeholder="输入标签内容" style="width:24em;"/>-->
<!--      </el-form-item>-->
    </el-form>
    <div class="dialog-footer" style="text-align: center">
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click="summit" v-loading="loading">确定</el-button>
    </div>
  </div>

</template>

<script>
import { postFormData } from "@/api/api"
import { addOrUpdateInfoLabelType } from "@/api/url";

export default {
  name: "TagManageDialog",
  props: {
    value: Object
  },
  data() {
    return {
      tagForm: this.value.tagForm,
      // infoLabelList: this.value.tagForm.infoLabelList?this.value.tagForm.infoLabelList.join("\n"):'',
      idx: this.value.ids,
      loading: false,

      names: [],

    }
  },
  methods: {
    cancel() {
      this.$emit("close");
    },

    //更改或添加
    headImgUpdate() {
      this.$refs.headImg.click();
    },

    //选取图片
    headImgChanged(e) {
      if(e.target.files[0]) {
        this.files = e.target.files[0];
        var windowURL = window.URL || window.webkitURL;
        this.src = windowURL.createObjectURL(this.files);
      }
    },

    summit() {
      if(!this.tagForm.name) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '类目名称不能为空',
          type: 'warning'
        });
        return false
      }
      if(!this.tagForm.orderNum) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '排序不能为空',
          type: 'warning'
        });
        return false
      }
      // if(!this.infoLabelList) {
      //   this.$message({
      //     showClose: true,
      //     duration: 2000,
      //     message: '内容不能为空',
      //     type: 'warning'
      //   });
      //   return false
      // }
      this.loading = true
      let param = {};
      param['id'] = this.tagForm.id?this.tagForm.id:0;
      param['name'] = this.tagForm.name;
      param['orderNum'] = this.tagForm.orderNum;
      // param['infoLabelNameArr'] = this.infoLabelList.split('\n');
      postFormData(addOrUpdateInfoLabelType, param).then((data) => {
        let {msg, code} = data
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'success'
          });
          this.$emit('confirm')
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
        this.loading = false
      }).catch(()=>{
        this.loading = false
      })
    }
  },
  mounted() {
  }
}
</script>

<style scoped>
.add {
  width: 80px;
  height: 80px;
  text-align: center;
  line-height: 80px;
  border: 1px dashed #ececec;
  font-size: 30px;
  cursor: pointer;
  float: left;
}
</style>
